import React from 'react';


import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import 'dayjs/plugin/utc'

import { Box, Typography, Card, CardContent, TextField, FormControl, InputLabel, MenuItem, Divider } from '@mui/material';

import Select from '@mui/material/Select';
import { Transport, Pipeline, openURL, iconColors } from '../helpers/scripts'
import { useNavigate } from 'react-router-dom';

import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import LinkRoundedIcon from '@mui/icons-material/LinkRounded';
import LaunchIcon from '@mui/icons-material/Launch';


const ModuleShipment = ({ shipment, updateShipment }) => {

    let navigate = useNavigate()

    const st = {
        fontSize: 14,
        mt: '6px'
    }

    const data = {
        // "date": "2024-02-20T03:55:03+00:00",
        // "id": "c65671b9-5133-49bd-a750-68460a6aea2c",
        // "isDelivery": false,
        // "last_update_comment": "",
        // "last_update_date": "2024-02-20T14:44:50+00:00",
        // "last_update_status": "Pris en charge",
        // "order_id": "63209472-6f5c-4703-8c6f-e3266fbf0437",
        // "step_id": 3,
        // "tracking_id": "LL014916959FR",
        // "tracking_link": "https://www.etracking.io/number/0cfc050fff2912c95d4b3d4c3c63c9d02a28ffd8",
        // "transport": "mydelivengo"
    }


    return (
        <>
            {shipment.id ?

                <div style={{ marginBottom: '20px', marginTop: '10px' }}>
                    <Divider sx={{ my: 2 }} />
                    <Box sx={{ paddingBottom: '0px', display: 'flex', justifyContent: 'space-between' }}>

                        <div style={{ display: 'flex' }}>
                            <Typography variant='subtitle1' color="initial" onDoubleClick={() => { console.log(shipment) }} >Доставка </Typography>
                            <LinkRoundedIcon
                                sx={{ ml: 1, mt: '4px', cursor: 'pointer', color: iconColors.blue }}
                                onClick={() => {
                                    navigate(`/shipments/${shipment.id}`)
                                }}
                            />
                        </div>

                    </Box>

                    <div style={{ display: 'flex', pb: '0' }}>


                        <Card sx={{ pt: '5px', mt: 3, mr: 3, width: '30%' }}>

                            <CardContent sx={{ display: 'grid' }}>

                                <TextField
                                    name='date'
                                    id='shipingDate'
                                    onChange={(e) => updateShipment(e)}
                                    value={dayjs(shipment.date).format('YYYY-MM-DDTHH:mm:ss')} // "2018-06-12T19:30"
                                    label="Дата"
                                    type='datetime-local'
                                    autoComplete=''
                                    InputLabelProps={{ shrink: true }}
                                    sx={{ mr: 2, width: '250px', mt: 2 }}

                                />

                                <TextField
                                    name='last_update_date'
                                    id='shipingLast_update_date'
                                    onChange={(e) => updateShipment(e)}
                                    value={dayjs(shipment.last_update_date).format('YYYY-MM-DDTHH:mm:ss') || undefined} // "2018-06-12T19:30"
                                    label="Дата статуса"
                                    type='datetime-local'
                                    // onDoubleClick={(e)=>console.log(e.target.value)}
                                    autoComplete=''
                                    InputLabelProps={{ shrink: true }}
                                    sx={{ mr: 2, width: '250px', mt: 2 }}
                                    disabled
                                />

                                <FormControl sx={{ width: '250px', mt: 2 }} >
                                    <InputLabel id="shipingTransport">Транспорт</InputLabel>
                                    <Select
                                        labelId="shipingTransport"
                                        id="shipingTransport"
                                        value={shipment.transport}
                                        label="Транспорт"
                                        name='transport'
                                        onChange={(e) => updateShipment(e)}
                                        sx={{ fontSize: 'smaller' }}

                                    >
                                        {Transport.map(i => <MenuItem key={i['code']} value={i['code']}> {i['name']} </MenuItem>)}

                                    </Select>
                                </FormControl>


                            </CardContent>
                        </Card>

                        <Card sx={{ pt: '5px', mt: 3, mr: 3, width: '30%' }}>
                            <CardContent sx={{ display: 'grid' }}>

                                <FormControl sx={{ width: '250px', mt: 2 }} >
                                    <InputLabel id="shipingStep">Этап по доставке</InputLabel>
                                    <Select
                                        labelId="shipingStep"
                                        id="shipingStep"
                                        value={+shipment.step_id}
                                        label="Этап по доставке"
                                        name='step_id'
                                        onChange={(e) => updateShipment(e)}
                                        sx={{ fontSize: 'smaller' }}

                                    >
                                        {Pipeline.map(i => <MenuItem key={i['code']} value={i['code']}> {i['name']} </MenuItem>)}

                                    </Select>
                                </FormControl>


                                <FormControl sx={{ width: '250px', mt: 2 }} >
                                    <InputLabel id="shipingStep">Доставлен</InputLabel>
                                    <Select
                                        labelId="isDelivery"
                                        id="isDelivery"
                                        value={shipment.isDelivery}
                                        label="Доставлен да / нет"
                                        name='isDelivery'
                                        onChange={(e) => updateShipment(e)}
                                        sx={{ fontSize: 'smaller' }}

                                    >
                                        <MenuItem value={false}> Нет </MenuItem>
                                        <MenuItem value={true}> Да </MenuItem>

                                    </Select>
                                </FormControl>

                            </CardContent>
                        </Card>

                        <Card sx={{ pt: '5px', mt: 3, width: '40%' }}>
                            <CardContent sx={{ display: 'grid' }}>

                                <TextField
                                    name='tracking_id'
                                    id='shipingTrackingId'
                                    value={shipment.tracking_id}
                                    label="Номер отправки"
                                    InputLabelProps={{ shrink: true }}
                                    onChange={(e) => updateShipment(e)}
                                    autoComplete='off'
                                    sx={{ mr: 2, width: '250px', mt: 2 }}
                                />

                                <TextField
                                    name='last_update_status'
                                    id='shipingLast_update_status'
                                    value={shipment.last_update_status}
                                    onChange={(e) => updateShipment(e)}
                                    label="Комментарий статуса"
                                    InputLabelProps={{ shrink: true }}
                                    autoComplete='off'
                                    sx={{ mr: 2, width: '250px', mt: 2 }}
                                    disabled
                                />


                                <div>
                                    <TextField
                                        name='tracking_link'
                                        id='shipingTracking_link'
                                        value={shipment.tracking_link}
                                        onChange={(e) => updateShipment(e)}
                                        label="Ссылка на отслеживание"
                                        InputLabelProps={{ shrink: true }}
                                        autoComplete='off'
                                        sx={{ mr: 2, mt: 2, width: '300px' }}
                                    />

                                    <ContentCopyIcon
                                        sx={{ cursor: 'pointer', width: '10%', mt: '30px', color: '#7f7f7f' }}
                                        onClick={() => { navigator.clipboard.writeText(shipment.tracking_link) }} />

                                    <LaunchIcon
                                        sx={{ cursor: 'pointer', width: '10%', color: '#7f7f7f' }}
                                        onClick={() => openURL(shipment.tracking_link)} />

                                </div>



                            </CardContent>
                        </Card>
                    </div>

                </div>

                : ''}
        </>
    );
}

export default ModuleShipment;
